// extracted by mini-css-extract-plugin
export default {"title":"fQxGCAkdWH3SPQ37YCQm","subtitle":"iKuBExIy4RFR8NW64A6Y","error":"pD1vIAuMtb2p8IPzVmys"};